import {h, Component} from 'preact';
import {labels, space} from '../styles';
import {
    PageContent,
    BackButton,
    RmaLineItemShort,
    VendorLabel,
    RmaStatusMeter,
    RmaStatusBadge,
    ContactInfo,
    RmaDateBadge
} from '../components';
import {hasReceivedSomeItems} from '../helpers';

function getRmaStatus ( {rmaStatus, rmaLineItems} ) {
    if ( rmaStatus === 'CLOSED' || rmaStatus === 'CANCELED' || rmaStatus === 'COMPLETE' ) {
        return rmaStatus.toLowerCase();
    }

    // if rmsStatus does not match on of the above assume RMA is OPEn|HOLD and determine status by aggregating unit status
    return hasReceivedSomeItems( rmaLineItems ) ? 'received' : 'waiting';
}

export const RmaDetail = props =>
    <PageContent>
        <BackButton history={props.history}/>
        <div className="mt-4 flex w-full">
            <div className="flex-1">
                <div className="md:flex">
                    <div className="flex-1">
                        <h3 className={labels.rmaTitle}>
                            Repair Request Detail &ndash; {props.requestId}
                        </h3>
                        <RmaDateBadge className="mt-2" date={props.createdDate}/>
                        <RmaStatusBadge className="mt-4" status={props.requestStatus}/>
                        <div className="mt-4">
                            <h4>Repairs fulfilled by</h4>
                            <VendorLabel className="block" name={props.vendor}/>
                        </div>
                        <div className="mt-4">
                            <h4>Issued by</h4>
                            <ContactInfo
                                firstName={props.firstName}
                                lastName={props.lastName}
                                email={props.email}
                            />
                        </div>
                    </div>
                    <RmaStatusMeter {...props} status={getRmaStatus( {
                        createdDate: props.createdDate,
                        rmaStatus: props.requestStatus,
                        rmaLineItems: props.rmaLineItems
                    } )}/>
                </div>
                <section className="mt-4 md:mt-10">
                    <div className={`hidden mt-4 md:grid md:grid-col-5 ${labels.thead}`}>
                        <span className={`hidden md:block md:w-64 ${space.th}`}>Item name</span>
                        <span className={space.th}>Serial Number</span>
                        <span className={space.th}>LOT</span>
                        <span className={space.th}>Date Received</span>
                        <span className={space.th}>Item Progress</span>
                    </div>
                    {props.rmaLineItems.map(
                        item => <RmaLineItemShort key={item.id} rmaStatus={props.requestStatus} {...item}/> )
                    }
                </section>
            </div>
        </div>
    </PageContent>;